export default "__VITE_ASSET__on08109H__"